import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3ModbusSettings } from 'ngx-modbus';

export const MODBUS_RS485_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'modbus-rs485-config',
  name: 'Modbus RS485 Configuration',
  sections: [{
    id: 'rs485',
    labelKey: 'modbusConfiguration',
    registerTable: 'V3ModbusSettings',
    controlRegister: 'RS485Config_Control',
    validityMask: 'AddressMask_Config_Basic1',
    fields: [
      fieldRef(V3ModbusSettings, 'RS485Config_Address'),
      fieldRef(V3ModbusSettings, 'RS485Config_Baud'),
      fieldRef(V3ModbusSettings, 'RS485Config_StopBit'),
      fieldRef(V3ModbusSettings, 'RS485Config_ParityBit'),
    ],
  }],
};
